var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-input"},[_c('div',{staticClass:"label"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.labelText))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }